import * as React from 'react'
import { graphql, navigate, PageProps } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { FormattedMessage } from 'gatsby-plugin-intl'

import { getRedirectLanguage } from '../utils'
import Layout from '../containers/layout'
import Header from '../components/header'
import Footer from '../components/footer'
import Investors from '../components/investors'
import Inquiry from '../components/inquiry'

const mapQuery = encodeURIComponent(
  '新宿ワシントンホテル 本館 東京都新宿区西新宿3-2-9',
)

export const pageQuery = graphql`
  query CompanyInvestorsData {
    allContentfulInvestors(
      filter: { node_locale: { regex: "/^en/" } }
      sort: { fields: priority, order: ASC }
    ) {
      edges {
        node {
          id
          logo {
            localFile {
              childImageSharp {
                gatsbyImageData(height: 80)
              }
            }
          }
          name
          url
          priority
        }
      }
    }
  }
`

const CompanyPage: React.FC<PageProps> = ({ location, pageContext }) => {
  React.useEffect(() => {
    const urlLang = getRedirectLanguage()
    if (location.pathname.startsWith('/en/') && urlLang === '/') {
      const newPathname = location.pathname.replace('/en/', '/')
      void navigate(newPathname)
    }
  }, [location.pathname])

  return (
    <Layout id="content" subtitle="Company" pageContext={pageContext}>
      <section id="top">
        <Header location={location} pageContext={pageContext} />
        <div className="inner">
          <h1 className="title fadeup">Company</h1>
        </div>
      </section>

      <div className="content-wrap">
        <section className="message">
          <div className="inner">
            <div className="message-visual fadeup">
              <StaticImage
                src="../images/message-visual.jpg"
                alt="CEO"
                loading="eager"
              />
            </div>
            <div className="message-text">
              <h2 className="heading fadeup">
                <FormattedMessage id="company_title" />
              </h2>
              <p className="fadeup-delay">
                <p>
                  <FormattedMessage id="company_text_1" />
                </p>
                <p>
                  <FormattedMessage id="company_text_2" />
                </p>
                <p>
                  <FormattedMessage id="company_text_3" />
                </p>
                <p>
                  <FormattedMessage id="company_text_4" />
                </p>
                <p>
                  <FormattedMessage id="company_text_5" />
                </p>
              </p>
              <p className="name fadeup-delay">
                <FormattedMessage id="company_ceo_name" />
              </p>
            </div>
          </div>
        </section>
        <section className="profile fadeup">
          <div className="inner">
            <table>
              <tbody>
                <tr>
                  <th aria-label="Company Name">
                    <FormattedMessage id="company_info_name_head" />
                  </th>
                  <td>
                    <FormattedMessage id="company_info_name_text" />
                  </td>
                </tr>
                <tr>
                  <th aria-label="Place">
                    <FormattedMessage id="company_info_location_head" />
                  </th>
                  <td>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="company_info_location_text" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <th aria-label="CEO">
                    <FormattedMessage id="company_info_ceo_head" />
                  </th>
                  <td>
                    <FormattedMessage id="company_info_ceo_text" />
                  </td>
                </tr>
                <tr>
                  <th aria-label="Establishment">
                    <FormattedMessage id="company_info_establishment_head" />
                  </th>
                  <td>
                    <FormattedMessage id="company_info_establishment_text" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="map">
              <iframe
                src={`https://www.google.com/maps?q=${mapQuery}&z=17&output=embed`}
                frameBorder={0}
                allowFullScreen
                aria-hidden={false}
                title="map"
              />
            </div>
          </div>
        </section>

        <Investors />
      </div>

      <Inquiry />
      <Footer location={location} />
    </Layout>
  )
}

export default CompanyPage
